import { Component, OnInit, Inject } from '@angular/core';
import { Globals } from '../../../../globals'
import { IFormConferenceInvitation } from "../../../../Models/Forms/IFormConferenceInvitation";
import { FormConferenceInvitationService } from "../../../../Services/FormConferenceInvitationService";
import { IepService } from "../../../../Services/IepService";
import { ISpedStudentDemographics } from '../../../../Models/ISpedStudentDemographics'
import { IIepInstance } from '../../../../Models/IIepInstance'
import { ISitePauDetail } from '../../../../Models/ISitePauDetail'
import { Message } from 'primeng/primeng';
import { ILockStatus } from '../../../../Models/ILockStatus';
import { Router } from "@angular/router";
import { ILookupSite } from '../../../../Models/ILookupSite';
import { LookupService } from 'src/app/Services/LookupService';
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { SpinnerBase } from '../../../Base/SpinnerBase';
import { ReportService } from 'src/app/Services/ReportService';
import { SiteService } from 'src/app/Services/SiteService';

@Component({
    selector: 'MeetingNotification',
    templateUrl: './MeetingNotification.component.html',
    styleUrls: ['./MeetingNotification.component.css']
})

export class FormMeetingNotificationComponent extends SpinnerBase implements OnInit {
  _myGlobals: Globals;
  _baseUrl: string;
  _iepService: IepService;
  successMessages: Message[];
  errorMessages: Message[];
  studentInfo: ISpedStudentDemographics;
  selectedIepInstance: IIepInstance;
  isLocked: boolean;
  lockStatus: string;
  canEditIep: boolean;
  saveClicked: boolean;
  conferenceInvitationDB: IFormConferenceInvitation = {} as IFormConferenceInvitation;
  lookupSite: any = [];
  lookupSiteName: string;
  lookupSiteAddress: string;
  schoolAddress: any = [];
  meetingStartTime: Date;
  meetingEndTime: Date;
  lookupSiteList: ILookupSite[];
  sitePauDetailArray: ISitePauDetail[];
  selectedSitePauDetail: ISitePauDetail;
  _lookupService: LookupService;
  _siteService: SiteService;
  reportParamArray: IReportParameter[];

  constructor(
    private globals: Globals,
    reportService: ReportService,
    private _formConferenceInvitationService: FormConferenceInvitationService,
    iepService: IepService,
    siteService: SiteService,
    @Inject('BASE_URL') baseUrl: string,
    public router: Router,
    lookupService: LookupService) {
    super(reportService);
    this._iepService = iepService;
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this._lookupService = lookupService;
    this._siteService = siteService;
  }

  ngOnInit(): void {
    this.LoadFormConferenceInvitationDetails();
    this.LoadLookupValues();
    this.isLocked = false;
    this.canEditIep = this._myGlobals.canEdit();
    this.successMessages = [];
    this.errorMessages = [];
    this.scrollToTop();
    this.selectedSitePauDetail = {} as ISitePauDetail;
    this.studentInfo = this._myGlobals.spedStudentDemographics;
    this.selectedIepInstance = this._myGlobals.selectedIepInstance;
  }

  LoadLookupValues(): void {
    this._siteService.getActiveSiteDetails().subscribe((res: ISitePauDetail[]) => {
      this.sitePauDetailArray = [] as ISitePauDetail[];
      this.sitePauDetailArray.push({ siteName: 'Select the Meeting Location', siteId: null, pauName: null, address: null, city: null, stateCode: null, zipCode: null, formattedAddress: null, administratorName: null, sitePhone: null });
      this.sitePauDetailArray.push.apply(this.sitePauDetailArray, res);
    },
      err => console.error(err)
    );
  }

  LoadOneSite(): void {
    this._lookupService.getLookupSite(this._baseUrl + 'api/Lookup/getLookupSite/' + this.conferenceInvitationDB.siteId)
      .subscribe((res: ILookupSite[]) => {
        this.lookupSite = res
        this.lookupSiteName = this.lookupSite.label
      },
        err => console.error(err)
      );
  }

  changeSiteAddress(event): void {
    if (this.selectedSitePauDetail.siteId != undefined) {
      this.conferenceInvitationDB.siteId = this.selectedSitePauDetail.siteId;
      this.conferenceInvitationDB.schoolAddress = this.selectedSitePauDetail.formattedAddress;
    }
  }

    LoadFormConferenceInvitationDetails(): void {
      this._formConferenceInvitationService.getFormConferenceInvitation(this._myGlobals.selectedFormDetails.formId)
            .subscribe((res: IFormConferenceInvitation) => {
              this.conferenceInvitationDB = res;
              if (this.conferenceInvitationDB.schoolAddress != null) {
                this.schoolAddress = this.conferenceInvitationDB.schoolAddress.split(',');
              }
              this.conferenceInvitationDB.dateOfNotice = this.conferenceInvitationDB.dateOfNotice == null ? null : new Date(this.conferenceInvitationDB.dateOfNotice);
              this.conferenceInvitationDB.conferenceDate = this.conferenceInvitationDB.conferenceDate == null ? null : new Date(this.conferenceInvitationDB.conferenceDate);
              if (this.conferenceInvitationDB.siteId != null && this.conferenceInvitationDB.siteId != "---") {
                this.LoadOneSite();
              }

              let curDate = new Date(Date());

              if (this.conferenceInvitationDB.conferenceTime != null) {
                this.meetingStartTime = new Date(curDate.getFullYear() + " " + this.conferenceInvitationDB.conferenceTime);
              }
              else {
                this.meetingStartTime = null;
              }

              if (this.conferenceInvitationDB.endConferenceTime != null) {
                this.meetingEndTime = new Date(curDate.getFullYear() + " " + this.conferenceInvitationDB.endConferenceTime);
              }
              else {
                this.meetingEndTime = null;
              }

              if (this.conferenceInvitationDB.siteId != null) {
                this.selectedSitePauDetail = this.sitePauDetailArray.find(x => x.siteId === this.conferenceInvitationDB.siteId );
              }
            },
                err => console.error(err)
            );
    }

  clearMessages() {
    this.successMessages = [];
    this.errorMessages = [];
  }

  addMessage(msg: Message) {
    if (msg.severity == 'error') {
      this.errorMessages = [...this.errorMessages, msg];
    }
    else {
      this.successMessages = [...this.successMessages, msg];
    }
  }

    //Save the conference Invitation
  save(action) {
    this.scrollToTop();
    this.clearMessages();
    this.saveClicked = true;

    if (this.meetingStartTime != null) {
      this.conferenceInvitationDB.conferenceTime = this.meetingStartTime.getHours().toString().padStart(2, '0') + ":" + (this.meetingStartTime.getMinutes().toString().padStart(2, '0'));
    }
    if (this.meetingEndTime != null) {
      this.conferenceInvitationDB.endConferenceTime = this.meetingEndTime.getHours().toString().padStart(2, '0') + ":" + (this.meetingEndTime.getMinutes().toString().padStart(2, '0'));
    }

    //update values
    this._formConferenceInvitationService.insertUpdateFormConferenceInvitation(this.conferenceInvitationDB)
      .subscribe((res: IFormConferenceInvitation) => {
        let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: res.id.toString() }
        this.addMessage(successMessage);
        if (action == 'Close') {
          this.globals.editMode = false;
          this.loadUnLock("UnLock");
        }
        this.saveClicked = false
        this.validateForm();
        this.LoadFormConferenceInvitationDetails();
        this.scrollToTop();
      },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
          this.saveClicked = false;
        }
      )
  }

  validateForm() {
    this._formConferenceInvitationService.validateForm(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: string[]) => {
        for (var item of res) {
          let errorMessage: Message = { severity: 'error', summary: 'Validation Error', detail: item };
          this.addMessage(errorMessage);
        }
      },
        err => console.error(err)
      );
  }

    loadUnLock(action) {
        this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
            + this._myGlobals.selectedFormDetails.formInstanceId + '&action=' + action)
            .subscribe((res: ILockStatus) => {
                this.isLocked = res.success
                this.lockStatus = res.status
            },
                err => console.error(err)
            );
    }

    edit() {
        this.clearMessages();
        this.saveClicked = false;
        this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
            + this._myGlobals.selectedFormDetails.formInstanceId + '&action=Lock')
            .subscribe((res: ILockStatus) => {
                this.isLocked = res.success
                this.lockStatus = res.status
                if (this.isLocked == true) {
                    this.globals.editMode = true;
                }
                else {
                    let failedMessage: Message = { severity: 'warn', summary: this.lockStatus }
                    this.addMessage(failedMessage);
                }
            });
    }

    cancel() {
        this.clearMessages();
        this.globals.editMode = false;
        this.loadUnLock("UnLock");
        this.LoadFormConferenceInvitationDetails();
    }


  populateReportParameters() {
    this.reportParamArray = [];
    this.reportParamArray.push(
      { parameterName: 'RequestID', parameterValue: '0' },
      { parameterName: 'isDraft', parameterValue: 'False' },
      { parameterName: 'FormInstanceID', parameterValue: this.conferenceInvitationDB.iepFormInstanceId.toString() },
      { parameterName: 'ShowCustomWaterMark', parameterValue: 'False' },
      { parameterName: 'CustomWatermarkText', parameterValue: '' },
      { parameterName: 'ShowWaterMark', parameterValue: 'False' },
      { parameterName: 'BlankForm', parameterValue: 'false' }
    );
  }

  printEnglish() {
    this.populateReportParameters();
    this.printFormCommon(this.conferenceInvitationDB.rdlFileNameEnglish, this.reportParamArray);
  }

  printSpanish() {
    this.populateReportParameters();
    this.printFormCommon(this.conferenceInvitationDB.rdlFileNameSpanish, this.reportParamArray);
  }

}
